import React from "react";
import { Button, Modal } from "react-bootstrap";
// import { CheckCircleFill } from "react-bootstrap-icons";  // Using Bootstrap Icons
import styles from "./ConfirmationPop.module.scss";
import { VerifyIcon } from "Assets/icons";

const MailSentPopup = ({ confirmation, setConfirmation }) => {
    const hideHandler = () => {
        setConfirmation(false);
    };

    return (
        <Modal
            show={confirmation}
            onHide={hideHandler}
            backdrop="static"
            keyboard={false}
            centered
            className={`${styles.ConfirmationPop} custom-mail-sent-modal`}
        >
            <Modal.Body className={styles.modalBody}>
                <div className="text-center p-4">
                    {/* <CheckCircleFill size={60} className="text-success mb-3" /> */}
                    {/* <VerifyIcon/> */}

                    <h4 className="fw-bold mb-2 text-success">Mail Sent Successfully!</h4>
                    <p className="text-muted mb-4">
                        Account activation mail has been sent successfully.
                    </p>

                    <Button
                        type="button"
                        style={{ height: "30px", minWidth: "60px" }}
                        onClick={hideHandler}
                        className={`${styles.modalButton} px-4 btn text-white commonBtn fw-sbold`}
                    >
                        Close
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default MailSentPopup;
